import React from 'react';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism.css'; //Example style, you can use another

const SimpleCodeEditor = (props) => {
  const { text, setText } = props;
  return (
    <>
      <div className='d-flex'>
        <button className='btn btn-sm btn-outline-success ms-auto' onClick={() => setText(text)}>
          Prettify
        </button>
      </div>
      <Editor
        value={text}
        onValueChange={(text) => setText(text)}
        highlight={(text) => highlight(text, languages.sql)}
        padding={10}
        style={{
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: 12,
        }}
      />
    </>
  );
};

export default SimpleCodeEditor;
